import { createStylesContext } from "@chakra-ui/system"

export const [CardStylesProvider, useCardStyles] = createStylesContext("Card")
